import { SpatialOption, spatialValuesInRem } from './spatialValues';
import { pixelToRemConversion } from '@joykit/helpers/pixelToRemConversion';

export type SpatialStretchInsetOption = SpatialOption.sm | SpatialOption.md;
export type SpatialStretchInset = { [option in SpatialStretchInsetOption | SpatialOption.default]: string };

/**
 * Contrasted with a button or pill's squish, we occasionally horizontally stretch the inset of textboxes, textareas, and other form elements
 *
 * **Usage**: applied to buttons and cell-like containers like a data table or list item.
 * `padding: spatialStretchInset.default`
 */
export const spatialStretchInset: SpatialStretchInset = {
  default: `${pixelToRemConversion(24, 16, 'string')} ${spatialValuesInRem.md}`,
  sm: `${pixelToRemConversion(12, 16, 'string')} ${spatialValuesInRem.sm}`,
  md: `${pixelToRemConversion(24, 16, 'string')} ${spatialValuesInRem.md}`
};
